export default function Item({ icon, text = "" }) {
  return (
    <div key={text}>
      {icon && <img src={icon} alt="icon" />}
      <p>{text}</p>
    </div>
  );
}
